import styled from "@emotion/styled";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import { COLOR_GREY_6 } from "shared/theme/colors";
import { border } from "shared/theme/mixins";

export const StyledConfigs = styled(FlexColumn)`
  ${border(1, COLOR_GREY_6)};
  border-radius: 1rem;

  & > *:not(:last-child) {
    border-bottom: 1px solid ${COLOR_GREY_6};
  }
`;
